import React from "react";
import PropTypes from "prop-types";
import ClearIcon from "@mui/icons-material/Clear";
import { EDIT_COLUMNS } from "../../../../config/customerColumnsConfig";

const EditCustomerRow = ({
  customer,
  index,
  selectedCustomer,
  onRowClick,
  handlers,
  handleAutoSave,
}) => {
  const isSelected =
    selectedCustomer && selectedCustomer.customerID === customer.customerID;
  return (
    <tr
      onClick={() => onRowClick(customer)}
      className={`border-t cursor-pointer ${
        isSelected ? "bg-cyan-100" : "bg-transparent"
      } ${!isSelected ? "hover:bg-cyan-50 hover:shadow-lg" : ""}`}
    >
      <td className="px-1 py-1 border border-white bg-white text-center">
        <button
          onClick={() => handlers.removeCustomer(customer.customerID)}
          className="text-gray-500 hover:text-red-500 transition duration-150"
          aria-label="Remove customer"
        >
          <ClearIcon fontSize="small" />
        </button>
      </td>
      {EDIT_COLUMNS.map((col) => (
        <td key={col.key} className="px-1 py-1 border">
          {col.type === "select" ? (
            <select
              name={col.key}
              value={customer[col.key]}
              onChange={(e) => handlers.handleCustomerFieldChange(e, index)}
              onBlur={() => handleAutoSave(index)}
              className="w-full border-0 outline-none bg-inherit"
            >
              {col.options.map(([optionKey, optionLabel]) => (
                <option key={optionKey} value={optionKey}>
                  {optionLabel}
                </option>
              ))}
            </select>
          ) : (
            <input
              type={col.type}
              name={col.key}
              value={customer[col.key]}
              onChange={(e) => handlers.handleCustomerFieldChange(e, index)}
              onBlur={() => handleAutoSave(index)}
              className="w-full border-0 outline-none bg-inherit"
            />
          )}
        </td>
      ))}
    </tr>
  );
};

EditCustomerRow.propTypes = {
  customer: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectedCustomer: PropTypes.object,
  onRowClick: PropTypes.func.isRequired,
  handlers: PropTypes.shape({
    handleCustomerFieldChange: PropTypes.func.isRequired,
    removeCustomer: PropTypes.func.isRequired,
  }).isRequired,
  handleAutoSave: PropTypes.func.isRequired,
};

export default EditCustomerRow;
